/** Cmd on Mac, Ctrl everywhere else — used for shortcut hints (e.g. the command palette). */
export const isMacPlatform = () =>
  typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform ?? navigator.userAgent)
